import type { Cart } from 'bl-graphql'
import { triggerEcommerceEvent } from 'analytics/events'

import { formatSpaBookingToAnalyticsItems } from '../../../utils/get-analytics-items'

export const triggerAddShippingEvent = control => {
  const cart = control.flow.setupHook?.cart as Cart
  const analyticsItems = formatSpaBookingToAnalyticsItems(cart)

  triggerEcommerceEvent({
    event: 'add_shipping_info',
    meta: control.flow.setupHook?.ecommerceMeta,
    items: analyticsItems,
  })
}
